import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UrlConstants } from 'src/app/models/urlConstants';
import { ChartOptions } from 'src/app/screens/local-market/local-market.component';
import { MatDialog } from '@angular/material/dialog';
import { FundAccOrderModalComponent } from 'src/app/components/fund-acc-order-modal/fund-acc-order-modal.component';
import { Account, ClientData } from 'src/app/screens/user-profile/client-data';
import { AccountType, FundDetails, FundPriceChart, MutualFund,  CurencyID  } from 'src/app/models/mutualFund';
import { AccountService } from 'src/app/services/account.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-selected-symbol-charts',
  templateUrl: './selected-symbol-charts.component.html',
  styleUrls: ['./selected-symbol-charts.component.scss']
})
export class SelectedSymbolChartsComponent implements OnInit {

  @Input() fundDetails: FundDetails;
  @Input() fundPriceChartData: FundPriceChart;
  @Input() selectedFund: MutualFund;
  @Input() selectedaccount: MutualFund;
  lang: string;
  isDarkTheme: boolean;
  isEGID = UrlConstants.isEGID;
  chartOptions: ChartOptions;
  chartDataXaxis: string[];
  chartDataYaxis: number[];
  chartDataXaxisEnDirection: string[];
  chartDataXaxisArDirection: string[];
  isLoading: boolean = false;
  numberOfAccounts: number = 0;
  selectedAccount: Account;
  accountList: Account[];
  avbSetteledQty: number;
  userPortfolio: ClientData;
  highValueAnnual:number=40;
  highValueMonth:number=10;
  annualoptions = {};
  monthoptions = {};
  relationCode: any;
  AnnualChangePercentage: number;
  LastMonthChange:number;

  highValue:number=20;
  value: number = 0;
  options = {};
  hideSell: boolean= false;

  constructor(
    public dialog: MatDialog,
    public translate: TranslateService,
    private accountService: AccountService
  ) {
    this.lang = this.translate.currentLang
    this.isDarkTheme = localStorage.getItem("darktheme") == "dark" ? true : false;
    this.accountList = JSON.parse(localStorage.getItem("accList"))?.filter(acc => acc.accountType === AccountType.FUND);
    this.numberOfAccounts = this.accountList ? this.accountList.length : 0;
    this.selectedAccount = this.numberOfAccounts == 1 ? this.accountList[0] : null;

    this.annualoptions = {
      floor: 0,
      ceil: 40,
      step: 10,
      showTicks: true,
      showTicksValues: true,
      readOnly: true,
      rightToLeft: this.lang=="en" ? false : false
    };
    this.monthoptions = {
      floor: 0,
      ceil: 10,
      step: 1,
      showTicks: true,
      showTicksValues: true,
      readOnly: true,
      rightToLeft: this.lang=="en" ? false : false
    };
  }

  ngOnInit(): void {
    if (this.selectedFund) {
      this.AnnualChangePercentage = this.selectedFund.AnnualChangePercentage;
      this.LastMonthChange = this.selectedFund.LastMonthChange;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedFund']) {
      // Update values when selectedFund changes
      this.AnnualChangePercentage = this.selectedFund?.AnnualChangePercentage || 0;
      this.LastMonthChange = this.selectedFund?.LastMonthChange || 0;

    }


      if(changes['fundDetails'] && changes['fundDetails'].currentValue){
        this.checkHideShowSellIfOneAccount()
      }
    if (changes['fundPriceChartData']) {
      this.chartConfiguration(); // Reconfigure the chart
    }

    // If selectedFund or fundDetails change, re-fetch user portfolio data
    if (changes['selectedFund'] || changes['fundDetails'] || changes['selectedaccount']) {
      this.isLoading = true;
    }
  }

  checkHideShowSellIfOneAccount(){
    if(this.accountList.length==1){
      this.fetchUserPortfolio(this.accountList[0].relationCode)
    } else if(this.accountList.length>1)  {
      this.hideSell = false
    } else {
      this.hideSell = true
    }
  }

  chartTextColor(color: string): string[]{
    return new Array(this.chartDataXaxis?.length <= 10 ?10:this.chartDataXaxis?.length).fill(color)
  }
  chartConfiguration() {
    // Map the data for x-axis (date) and y-axis (closing price)
    this.chartDataXaxisEnDirection = this.fundPriceChartData?.Data.map((item) => item.Date.toString());
    this.chartDataXaxisArDirection = [...(this.chartDataXaxisEnDirection || [])].reverse();  // This can be kept if you still need to support RTL
    this.chartDataXaxis = this.chartDataXaxisEnDirection;  // Always use English format for x-axis dates
    this.chartDataYaxis = this.fundPriceChartData?.Data.map((item) => item.ClosePrice);

    if (this.fundPriceChartData && this.fundPriceChartData.Data) {
      // Configure chart options
      this.chartOptions = {
        chart: {
          type: 'area',
          height: 350,
        },
        series: [
          {
            name: 'Close Price',
            data: this.chartDataXaxis.map((date, index) => ({
              x: new Date(date).getTime(),
              y: this.chartDataYaxis[index],
            })),
          },
        ],
        xaxis: {
          sorted: false,
          type: 'datetime', // Ensure that the x-axis is treated as a datetime type
          axisBorder: {
            show: false,
          },
          labels: {
            // Use a formatter function to display the date in the desired format (YYYY-MM-DD)
            formatter: function (value: string) {
              const timestamp = Number(value);  // Convert string value to number if it's a string
              const date = new Date(timestamp);  // Convert timestamp to Date object
              const day = String(date.getDate()).padStart(2, '0'); // Add leading zero if single digit
              const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed, so add 1
              const year = date.getFullYear();
              return `${year}-${month}-${day}`; // Format as YYYY-MM-DD
            },
            style: {
              colors: this.isDarkTheme ? this.chartTextColor('#ffffff') : this.chartTextColor('#000000'),
            },
          },
        },
        yaxis: {
          opposite: false,  // This can be false to keep the y-axis on the left, as it's not RTL-specific anymore
          labels: {
            align: 'center',
            style: {
              colors: this.isDarkTheme ? this.chartTextColor('#ffffff') : this.chartTextColor('#000000'),
            },
          },
        },
        grid: {
          yaxis: {
            lines: {
              show: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: 'gradient',
          colors: ['#2988a0'],
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 1,
            opacityTo: 0.9,
            stops: [0, 100],
            gradientToColors: this.isDarkTheme ? ['#131722'] : ['#fff'],
          },
        },
        stroke: {
          show: false,
          curve: 'smooth',
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                height: 300,
              },
            },
          },
        ],
      };
    }
  }

  saveTabState(event: any) {
    let id = event.target.attributes.id;
    var tabs = document.querySelectorAll('.selection-tab');
    tabs.forEach(i => i.classList.remove('chart-tabs-active'));
    let element = document.getElementById(id.value);
    element?.classList.add('chart-tabs-active');
  }



  fetchUserPortfolio(relationCode: string){
    this.accountService.getClientInformation(relationCode)
    .subscribe(
      (res: ClientData)=>{
        if(res){
          this.userPortfolio = res
          if(this.fundDetails){
            if(this.fundDetails.CurencyID ==  CurencyID.EGP){
              this.hideSell = this.userPortfolio?.Portfolio?.EGPPortfolio?.Portfolio.find((item)=> item.ReutersCode == this.fundDetails.ReutersCode)?.AvbSetteledQty > 0 ? false : true;
              this.avbSetteledQty = this.userPortfolio?.Portfolio?.EGPPortfolio?.Portfolio.find((item)=> item.ReutersCode == this.fundDetails.ReutersCode)?.AvbSetteledQty
            } else if (this.fundDetails.CurencyID ==  CurencyID.USD){
              this.hideSell = this.userPortfolio?.Portfolio?.USDPortfolio?.Portfolio.find((item)=> item.ReutersCode == this.fundDetails.ReutersCode)?.AvbSetteledQty > 0 ? false : true;
              this.avbSetteledQty = this.userPortfolio?.Portfolio?.USDPortfolio?.Portfolio.find((item)=> item.ReutersCode == this.fundDetails.ReutersCode)?.AvbSetteledQty
            }
          }
        } else {
          this.userPortfolio = null
        }
      }
    )
  }


  fundActionModal(isBuy:boolean) {

        if (this.fundDetails.ClosePrice <= 0) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: this.translate.instant('fund-not-available'),
        showConfirmButton: true
      });
      return;
    }

    if(isBuy)
    {

      this.dialog.open(FundAccOrderModalComponent, {
        panelClass: "modal-width",
        data:{
          quantityAvailable : this.avbSetteledQty,
          isBuy : isBuy,
          selectedFund: this.selectedFund,
          fundDetails: this.fundDetails
        }
      });
    }
    else{
    if ( !this.hideSell ) {
      this.dialog.open(FundAccOrderModalComponent, {
        panelClass: "modal-width",
        data:{
          quantityAvailable : this.avbSetteledQty,
          isBuy : isBuy,
          selectedFund: this.selectedFund,
          fundDetails: this.fundDetails
        }
      });    }
    }

  }
}
